import { Component, OnInit, ViewChild } from '@angular/core';
import { TreeComponent } from 'src/app/tree/tree.component';
import { ReportService } from 'src/app/_service/report.service';
import { AuthService } from 'src/app/_service/auth.service';
import { AlertifyService } from 'src/app/_service/alertify.service';

@Component({
  selector: 'site-report',
  templateUrl: './site-report.component.html',
  styleUrls: ['./site-report.component.css']
})
export class SiteReportComponent implements OnInit {
  
  @ViewChild(TreeComponent, { static: true }) locationTree: TreeComponent;

  constructor(
    private reportService: ReportService,
    private authService: AuthService,
    private alertify: AlertifyService
  ) { }

  selectedLocations: any = ([] = []);
  siteReport: any;
  sdsUserId: any;
  sdsUserIdNumber: number;
  isLoading = false;
  loading = false;
  model: any;

  selectLocationRequired: any = {};
  generateModel: any = {};

  ngOnInit() {
    // get userid for location tree (for site admins)
    this.sdsUserId = this.authService.decodedToken.userid;
    this.sdsUserIdNumber = +this.sdsUserId;
  }

  createSiteReport() {
    this.isLoading = true;
    this.loading = true;

      // super admin location tree/location ID
      if (this.authService.decodedToken.role === 'Super Admin') {
        this.generateModel.LocationId = [];
        for (const loc of this.locationTree.checklistSelection.selected) {
            this.generateModel.LocationId.push(loc.authorityUnitId);
        }
      }

      if (this.authService.decodedToken.role === 'Site Admin') {
        this.generateModel.LocationId = [];
        for (const loc of this.locationTree.checklistSelection.selected) {
          if (loc.userId === this.sdsUserIdNumber) {
            this.generateModel.LocationId.push(loc.authorityUnitId);
          }
        }
      }
    this.reportService.generateSiteReport(this.generateModel).subscribe(
      res => {
        this.selectLocationRequired = res.headers.get('selectionrequired');
        if (this.selectLocationRequired) {
        this.loading = false;
        this.isLoading = false;
        this.alertify.message(this.selectLocationRequired);
        } else {
          if (res) {
            const link = document.createElement('a');
            if (window.navigator &&
              window.navigator.msSaveOrOpenBlob) { // for IE
              window.navigator.msSaveOrOpenBlob(res.body, 'Site' + `.xlsx`);
              this.loading = false;
              this.alertify.message('Site report generation is complete');
          } else {
            link.href = window.URL.createObjectURL(res.body);
            link.download = 'Site';
            link.click();
            this.loading = false;
            this.alertify.message('Site report generation is complete');
          }
          }
        }
      },
      error => {
        this.alertify.error(
          'Sites Report Generation failed, please try again!'
        );
        this.isLoading = false;
        this.loading = false;
      }
    );

    }


}
